import EventDispatcher from "../Event/EventDispatcher";

let eventDispatcher: EventDispatcher<any> | null = null;
let electron = window.require("electron");
let ipcMain = electron
    && electron.remote
    && electron.remote.getGlobal('ElectronIpcMain');
let ipcRenderer = electron && electron.ipcRenderer;

export default function getEventDispatcher(): EventDispatcher<any> {
    if (null === eventDispatcher) {
        eventDispatcher = new EventDispatcher<any>(
            ipcMain,
            ipcRenderer,
        );
    }

    return eventDispatcher;
}